import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { statusesAPI } from '../../services/api';

// Асинхронные экшены
export const fetchStatuses = createAsyncThunk(
  'statuses/fetchStatuses',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await statusesAPI.getAll(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchStatusById = createAsyncThunk(
  'statuses/fetchStatusById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await statusesAPI.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const statusesSlice = createSlice({
  name: 'statuses',
  initialState: {
    items: [],
    selectedStatus: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Синхронное обновление статуса (используется при получении событий)
    updateStatus: (state, action) => {
      const status = action.payload;
      const index = state.items.findIndex(item => item.id === status.id);
      
      if (index !== -1) {
        // Обновление существующего статуса
        state.items[index] = {
          ...state.items[index],
          ...status,
        };
      } else {
        // Добавление нового статуса
        state.items.push(status);
      }
      
      // Если открыта детальная страница статуса, обновляем и её
      if (state.selectedStatus && state.selectedStatus.id === status.id) {
        state.selectedStatus = {
          ...state.selectedStatus,
          ...status,
        };
      }
    },
    
    // Удаление статуса (используется при получении событий)
    deleteStatus: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter(item => item.id !== id);
      
      // Если открыта детальная страница удаляемого статуса, очищаем её
      if (state.selectedStatus && state.selectedStatus.id === id) {
        state.selectedStatus = null;
      }
    },
    
    // Сброс выбранного статуса
    resetSelectedStatus: (state) => {
      state.selectedStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Обработка fetchStatuses
      .addCase(fetchStatuses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatuses.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchStatuses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить статусы';
      })
      
      // Обработка fetchStatusById
      .addCase(fetchStatusById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatusById.fulfilled, (state, action) => {
        state.selectedStatus = action.payload;
        state.loading = false;
      })
      .addCase(fetchStatusById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить статус';
      });
  },
});

// Экспорт экшенов
export const { updateStatus, deleteStatus, resetSelectedStatus } = statusesSlice.actions;

// Селекторы
export const selectAllStatuses = (state) => state.statuses.items;
export const selectSelectedStatus = (state) => state.statuses.selectedStatus;
export const selectStatusesLoading = (state) => state.statuses.loading;
export const selectStatusesError = (state) => state.statuses.error;

// Экспорт редьюсера
export default statusesSlice.reducer; 